/**
 * Created by jv on 2019-10-17 (14:52).
 */
const log = require("Sources/utils/logger")();
import utils from "Sources/utils/utils";
import LanguageManager from "Sources/services/language-manager";

const CloseSvgIcon = require("!raw-loader!Images/icons/btn_plus.svg");

require("Styles/components/business-model-dialog.scss");
require("Styles/components/credits-dialog.scss");

import HtmlTemplate from "Views/partials/credits.html";

class CreditsDialog {
  constructor(options) {
    this.dialogId = utils.generateElementId("credits-dialog-");

    this.callbackContext = options.callbackContext;
    this.onCancel = options.onCancel;
  }

  get isOpen() {
    return utils.isNotNull(this.$dialog) && this.$dialog.length && this.$dialog.hasClass("show");
  }

  create() {
    if (this._initialized !== true) {
      this.renderDialog();

      this.$dialog.appendTo("body");
      this.initialize();
    }
  }

  initialize() {
    if (this._initialized !== true) {
      this.$dialog.modal({
        backdrop: false,
        show: false
      });

      this.setUpDialogEventListeners();

      this._initialized = true;
    }
  }

  renderDialog() {
    this.$dialog = $("<div id='" + this.dialogId + "' class='modal fade modal-credits' tabindex='-1' role='dialog' aria-hidden='true'>" +
      "<div class='modal-dialog modal-dialog-centered business-model-dialog credits-dialog'>" +
      "<div class='modal-content'>" +
      "</div>" +
      "</div>" +
      "</div>");

    this.renderDialogContent();
  }

  renderDialogContent() {
    let $dialogContent = this.$dialog.find(".modal-content");

    if (utils.isNotNull($dialogContent) && $dialogContent.length) {
      $dialogContent.empty();

      log.debug("Setting up credits dialog");

      let $closeBtn = $("<button class='btn dialog-close-btn' type='button'></button>");
      $closeBtn.html(CloseSvgIcon);
      $dialogContent.append($closeBtn);

      let $creditsContent = $(HtmlTemplate);
      $dialogContent.append($creditsContent);
      LanguageManager.applyLocale($creditsContent);

      this.setUpCloseRoundEventListeners();
    }
  }

  show(showBackdrop) {
    if (showBackdrop) {
      this.$dialog.addClass("modal-credits__backdrop");
    } else {
      this.$dialog.removeClass("modal-credits__backdrop");
    }

    this.$dialog.modal("show");
  }

  hide() {
    this.$dialog.modal("hide");
  }

  setUpDialogEventListeners() {

  }

  setUpCloseRoundEventListeners() {
    this.$dialog.find(".btn").on("transitionend", (e) => {
      // transitionend fix for dialog close animations
      e.preventDefault();
      e.stopPropagation();
      return false;
    });

    this.$dialog.find(".dialog-close-btn").on("click", (e) => {
      if (utils.isFunction(this.onCancel)) {
        this.onCancel.call(this.callbackContext, this);
      }
    });
  }
}

export default CreditsDialog;



// WEBPACK FOOTER //
// ./app/js/components/credits-dialog.js